<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="result.name" label="ID" outlined dense></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-text-field v-model="result.text" label="Szöveg" outlined dense></v-text-field>
    </v-col>
    <v-col cols="12" v-for="(prop, index) in result.props" :key="index">
      <v-row>
        <v-col cols="5">
          <v-text-field v-model="prop.text" label="Prop Szöveg" outlined dense @input="updateProps"></v-text-field>
        </v-col>
        <v-text-field
          v-model="prop.value"
          label="Prop Érték"
          outlined
          dense
          @input="updateProps"
          :class="{'red-text': isIndexInDupes(index)}"
        ></v-text-field>
        <v-col cols="2">
          <v-btn @click="removeProp(index)" icon dense>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-btn @click="addProp" outlined dense>Add Prop</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue';
import { findDuplicateIndices } from './helpers';

export default defineComponent({
  name: 'CheckboxOrMulti',
  props: {
    baseValue: {
      type: Object,
      default: () => ({
        name: '',
        text: '',
        props: []
      })
    }
  },
  data() {
    return {
      dupes: [],
      result: { ...this.baseValue },
    };
  },
  emits: ['formAddEvent'],
  methods: {
    isIndexInDupes(index) {
      return this.dupes.includes(index);
    },
    sendDataToParent() {
      const dataToSend = {
        name: this.result.name,
        text: this.result.text,
        props: this.result.props
      }
      this.$emit('formAddEvent', dataToSend);
    },
    addProp() {
      if(!this.result.props) this.result.props = []
      this.result.props.push({ text: '', value: '' });
      this.sendDataToParent();
    },
    removeProp(index) {
      this.result.props.splice(index, 1);
      this.sendDataToParent();
    },
    updateProps() {
      this.sendDataToParent();
    }
  },
  watch: {
    result: {
      handler() {
        this.dupes = findDuplicateIndices(this.result?.props, 'value')
        this.sendDataToParent();
      },
      deep: true,
      immediate: true
    }
  }
});
</script>

<style lang="css" scoped>
.red-text {
  color: red;
}
</style>
